/**
 * API Configuration Utility
 * Automatically selects the appropriate backend URL based on how the frontend is accessed
 */

/**
 * Get the appropriate API and Socket URLs based on the current hostname
 * @returns {object} { apiUrl, socketUrl }
 */
export const getApiUrls = () => {
    const hostname = window.location.hostname;

    // Check if accessing via localhost
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        return {
            apiUrl: process.env.REACT_APP_API_URL_LOCAL,
            socketUrl: process.env.REACT_APP_SOCKET_URL_LOCAL
        };
    }

    // Check if accessing via LAN IP (192.168.x.x or 10.x.x.x)
    if (hostname.startsWith('192.168.') || hostname.startsWith('10.')) {
        return {
            apiUrl: process.env.REACT_APP_API_URL_LAN,
            socketUrl: process.env.REACT_APP_SOCKET_URL_LAN
        };
    }

    // Production/Server (domain name)
    return {
        apiUrl: process.env.REACT_APP_API_URL_PROD,
        socketUrl: process.env.REACT_APP_SOCKET_URL_PROD
    };
};

/**
 * Get all available API URLs for manual selection
 * @returns {array} Array of { label, apiUrl, socketUrl }
 */
export const getAvailableApiUrls = () => {
    return [
        {
            label: 'Local Development',
            apiUrl: process.env.REACT_APP_API_URL_LOCAL,
            socketUrl: process.env.REACT_APP_SOCKET_URL_LOCAL
        },
        {
            label: 'LAN (Mobile Testing)',
            apiUrl: process.env.REACT_APP_API_URL_LAN,
            socketUrl: process.env.REACT_APP_SOCKET_URL_LAN
        },
        {
            label: 'Production Server',
            apiUrl: process.env.REACT_APP_API_URL_PROD,
            socketUrl: process.env.REACT_APP_SOCKET_URL_PROD
        }
    ];
};

// For backward compatibility, export the auto-selected URLs
const { apiUrl, socketUrl } = getApiUrls();
export const API_URL = apiUrl;
export const SOCKET_URL = socketUrl;

/**
 * Get full URL for uploaded assets (avatars, gallery images, etc.)
 * When frontend runs as static files, upload paths like '/uploads/xxx' need 
 * to be prefixed with backend URL since files are stored on backend server.
 * @param {string} path - The upload path (e.g., '/uploads/avatars/user.jpg')
 * @returns {string} Full URL to the uploaded asset
 */
export const getUploadUrl = (path) => {
    if (!path) return '';
    // If already a full URL, return as is
    if (path.startsWith('http://') || path.startsWith('https://')) {
        return path;
    }
    // Prepend backend URL to relative upload paths
    return `${socketUrl}${path}`;
};

// Log the selected endpoints for debugging
console.log('[API Config] Auto-selected endpoints:');
console.log('  Frontend accessed via:', window.location.hostname);
console.log('  API URL:', apiUrl);
console.log('  Socket URL:', socketUrl);

